import { c as _c } from "react/compiler-runtime";
import { CallPatient } from ".";
import { IoArrowBack } from "react-icons/io5";
import { PatientIdentifier } from "@/components/patient/patient-identifier";
import { ProgressBarLink } from "@/components/progress-bar";
import { Button } from "@/components/ui";
import { formatName, formatPhoneNumber } from "@/lib/format-data";
interface PatientDetailsProps {
  patient: CallPatient;
  callOngoing: boolean;
  showBackButton: boolean;
  onBackClick: () => void;
}
const PatientDetails: React.FC<PatientDetailsProps> = t0 => {
  const $ = _c(31);
  const {
    patient,
    callOngoing,
    showBackButton,
    onBackClick
  } = t0;
  let t1;
  if ($[0] !== patient.firstName || $[1] !== patient.lastName) {
    t1 = patient.firstName ? formatName(patient.firstName, patient.lastName) : null;
    $[0] = patient.firstName;
    $[1] = patient.lastName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const displayName = t1;
  let t2;
  if ($[3] !== patient.phoneNumber) {
    t2 = formatPhoneNumber(patient.phoneNumber);
    $[3] = patient.phoneNumber;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const formattedPhone = t2;
  let t3;
  if ($[5] !== callOngoing) {
    t3 = callOngoing ? <span>{"Calling "}</span> : <span>{"Make a call to "}</span>;
    $[5] = callOngoing;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `/patient/${patient.id}`;
  const t5 = displayName || formattedPhone || "Unknown";
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <ProgressBarLink href={t4} className="cursor-pointer hover:text-primary hover:underline">{t5}</ProgressBarLink>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <h3 className="text-h3 font-medium leading-6 text-foreground">{t3}{t6}</h3>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== displayName || $[14] !== formattedPhone || $[15] !== patient.phoneNumber) {
    t8 = displayName && patient.phoneNumber && <p>{formattedPhone}</p>;
    $[13] = displayName;
    $[14] = formattedPhone;
    $[15] = patient.phoneNumber;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== patient) {
    t9 = <PatientIdentifier patient={patient} className="italic" />;
    $[17] = patient;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <div className="mt-1 space-y-0.5 text-body text-muted-foreground">{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t7) {
    t11 = <div>{t7}{t10}</div>;
    $[22] = t10;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== onBackClick || $[26] !== showBackButton) {
    t12 = showBackButton && <Button variant="ghost" onClick={onBackClick}><IoArrowBack className="h-5 w-5" /></Button>;
    $[25] = onBackClick;
    $[26] = showBackButton;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12) {
    t13 = <div className="flex items-center justify-between">{t11}{t12}</div>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
};
export default PatientDetails;